module.exports = __webpack_public_path__ + "img/participants2.2a1a9af3.svg";